<template>
<div class="form-body">
  <div class="row">
    <div class="form-holder">
      <div class="form-content">
        <div class="form-items">
          <span class="logo-lg"><img class="img" src="../../../assets/img/logo-black.png"></span>
          <!-- <h3>Welcome to Screenit</h3> -->
          <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer placerat mi fringilla mauris ullamcorper</p> -->
          <div class="container" style="width: 100% !important;">
            <div class="col-md-12">
              <div class="box">
                <!-- <div class="box-header with-border">
                  <h4 class="box-title">Join Interview</h4>
                </div> -->
                <div class="box-body">
                  <h4 class="box-title">{{header}}</h4>
                  <img class="img" src="../../../assets/img/meeting_expired.svg">
                </div>
                <div class="box-footer clearfix">
                  <span>{{msg}}</span>
                  <!-- <a @click="viewresult()" v-if="type == 1" class="btn btn-sm btn-success btn-flat pull-right">view Result</a> -->
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Cookies from 'js-cookie'
import axios from 'axios'
import { BaseURL } from '../../../shared/classes'
// import router from '../../../router/index'
import { logo } from '../../../shared/svg'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import momentsone from 'moment-timezone'

export default {
  data () {
    return {
      form: {
        email: '',
        name: '',
        channel: ''
      },
      joinBtn: false,
      data: [],
      BaseURL: BaseURL,
      meetingid_error: false,
      meetingid: '',
      baseMode: 'avc',
      transcode: 'interop',
      attendeeMode: 'video',
      timezone: momentsone.tz.guess(),
      currentTimezone: 'IST',
      videoProfile: '480p_4',
      logos: logo,
      type: this.$route.params.type,
      org: this.$route.params.org,
      start_datetime: '',
      end_datetime: '',
      config: {
        headers: {
          'content-type': 'application/json'
          // Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      msg: '',
      header: ''
    }
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      email: {
        required,
        email
      },
      name: {
        required
      },
      channel: {
        required
      }
    }
  },
  created () {
    console.log(this.$route.params.id)
    Cookies.set('sid', this.$route.params.id)
    this.getscheduleDetails(this.$route.params.id)
    if (this.timezone === 'America/New_York') {
      this.currentTimezone = 'EST'
    } else {
      this.currentTimezone = 'IST'
    }
  },
  methods: {
    getDate (date) {
      return momentsone.utc(date).tz(this.timezone).format('DD MMM YYYY')
    },
    getTime (date) {
      return momentsone.utc(date).tz(this.timezone).format('hh:mm a')
    },
    viewresult () {
      this.$router.push('/result')
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    getscheduleDetails (id) {
      const mainurl = '/dashboard/get_schedule_detail/' + id
      axios.get(`${this.BaseURL}${mainurl}`, this.config).then(response => {
        if (response.data.refer_tag !== 'self') {
          this.data = response.data.scheduleList[0]
        } else {
          this.data = response.data.scheduleList_self[0]
        }
        this.meetingid = this.data.meeting_id
        // this.end_datetime = this.data.enddatetime_utc
        // this.start_datetime = this.data.startdatetime_utc
        if (this.data.candidate_accept !== 'yes' && this.data.interviewer_accept === 'yes') {
          this.header = 'Acknowledgement Pending'
          this.msg = 'The candidate hasn\'t accept the schedule yet. We will keep you informed about the schedule.'
        } else if (this.data.candidate_accept === 'yes' && this.data.interviewer_accept !== 'yes') {
          this.header = 'Acknowledgement Pending'
          this.msg = 'Panel hasn\'t accept the schedule yet. We will keep you informed about the schedule.'
        }
        Cookies.set('job_title', this.data.job_tittle)
        Cookies.set('organization', this.data.organization)
        if (this.data.job_interview_type === 'video') {
          this.attendeeMode = 'video'
        } else {
          this.attendeeMode = 'audio-only'
        }
      }).catch(e => {
        console.log(e)
      })
    },
    handleChannel (val, state) {
      this.channel = val
      this.joinBtn = state
    },
    handleBaseMode (val) {
      this.baseMode = val
    },
    handleTranscode (val) {
      this.transcode = val
    },
    handleVideoProfile (val) {
      this.videoProfile = val
    },
    handleAttendeeMode (e) {
      this.attendeeMode = e.currentTarget.value
    },
    handleJoin () {
      if (this.validate()) {
        // if (this.meetingid !== this.channel) {
        //   this.meetingid_error = true
        //   return
        // } else {
        //   this.meetingid_error = false
        // }
        Cookies.set('channel', this.form.channel)
        Cookies.set('baseMode', this.baseMode)
        Cookies.set('transcode', this.transcode)
        Cookies.set('attendeeMode', this.attendeeMode)
        Cookies.set('videoProfile', this.videoProfile)
        // if (this.org === 'acs') {
        //   this.$router.push('/agora/meeting')
        // } else {
        //   this.$router.push('/agoraMod/meeting')
        // }
        this.$router.push('/agoraMod/meeting')
      } else {
        return false
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('keypress', e => {
        e.keyCode === 13 && this.handleJoin()
      })
    })
  }
}
</script>

<style scoped>
.passwardcompare {
  margin-top: 9px !important;
}
.img {
    width: 30% !important;
    margin-bottom: 15px;
}
.pwd_info {
  float: left;
  font-size: 12px;
  padding-bottom: 11px;
  color: red;
  margin-top: 0px;
}

.pwd_info_float_right {
  float: right;
  font-size: 12px;
  padding-bottom: 11px;
  color: #5BAD2B;
  /* cursor: pointer; */
  margin-top: -10px;
}

.pading_____zero {
  margin-bottom: 2px !important;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}

.form-holder {
  margin-left: 0px;
}

.login-policy-footer {
  width: 31%;
}

.progressbar {
  height: 5px !important;
  background: #e6e6e6;
}

ul {
  padding: 0px;
}

span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 0.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 7px;
}

.register____user__type {
  color: #000000;
  width: 44%;
  margin-left: 3%;
  margin-right: 3%;
  margin-bottom: 17px !important;
  cursor: pointer;
}

.progress_____round {
  border: 1px solid #5bad2b;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #5bad2b;
  font-weight: bold;
}

.progress_____round____hidden {
  border: 1px solid #bbb4b4;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #bbb4b4;
  font-weight: bold;
}
.form-content {
    width: auto;
}
.box {
  border-top: 0px solid #d2d6de;
  border-radius: 0px;
}
.form-content form {
    margin-bottom: 30px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
}
.box-header .box-title {
    display: inline-block;
    font-size: 16px;
    margin: 0;
    line-height: 1;
    color:black;
}
.form-content .form-items {
    max-width: 540px;
}
html {
  height: 100% !important;
}
.form-content {
  background-color: #F5F5F5 !important;
}
.form-body {
  background-color: #F5F5F5 !important;
}
input {
  background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #DCDCDC;
}
.color-g {
  color: #5bad2b;
}
</style>
